export class Asset {
	// TODO wdsDecom: this needs to update for pas asset
	public assetClass: string;
	public assetBreakdowns: any;
	public assetType: string;
	public customClientProperties: any;
	public commonIdentifier: string;
	public commonIdentifierType: string;
	public erroneous: boolean;
	public identifier: string;
	public identifierType: string;
	public legalType: string;
	public name: string;
	public type: string;
	public ticker: string;
	public morningstarFundId: string;
	public morningstarCategory: string;
	public morningstarSecId: string;
	public globalId: string;
	public aladdinId: string;
	public assetId: string;
	public cusip: string;
	public isin: string;
	public funds: any;
	public currency: string;
	public regionCode: string;
	public market: string;
	public description: string;
	public classifications: { [classification: string]: string };
	public identifiers: Map<string, string>;
	public securityId: string;
	public isSelected?: boolean;

	/**
	 * GETTERS
	 */

	public getAssetClass(): string {
		return this.assetClass;
	}

	public getCommonIdentifier(): string {
		return this.commonIdentifier;
	}

	public getCommonIdentifierType(): string {
		return this.commonIdentifierType;
	}

	public isErroneous(): boolean {
		return this.erroneous;
	}

	public getIdentifier(): string {
		return this.identifier;
	}

	public getIdentifierType(): string {
		return this.identifierType;
	}

	public getName(): string {
		return this.name;
	}

	public getType(): string {
		return this.type;
	}

	public getIdentifiers(): Map<string, string> {
		return this.identifiers;
	}
	/**
	 * SETTERS
	 */

	public setName(name: string): void {
		this.name = name;
	}

	public setErroneous(erroneous: boolean): void {
		this.erroneous = erroneous;
	}
}
